import { setCountAction, setHeadlineTypeSync } from "./_common.js";
import stationTypeFilter from "./station-type-filter.js";

const main = () => {
    if (document.querySelector('#page-search-station') === null) return;
    setCountAction();
    setHeadlineTypeSync();
    stationTypeFilter();

    // bfcache から復元された場合は強制リロードして最新のセッション条件を反映する
    window.addEventListener('pageshow', (event) => {
        if (event.persisted) {
            window.location.reload();
        }
    });
}

export default main;
